import { Subject } from 'rxjs';
import { DeferredData, Rpc } from '../rpc';
import { RpcSubjectServer } from '../rpc-subject-server';
import { RpcDialogOverlayData, RpcOverlayOpenKey } from './rpc-overlay-model';
import { RpcOverlayOpenHandler } from './rpc-overlay-open-handler';

/**
 * Rpc overlay open subject interface.
 */
export interface RpcOverlayOpenSubject extends Subject<DeferredData<RpcDialogOverlayData, void>> {}

/**
 * The class to implement overlay open with Subject server.
 */
export class RpcOverlayOpenSubjectServer extends RpcSubjectServer<RpcDialogOverlayData, void> implements RpcOverlayOpenHandler {
    /**
     * Initializes a new instance of the RpcOverlayOpenSubjectServer class.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcOverlayOpenKey.command);
    }

    /**
     * The handler to respond a request for RpcLog call.
     *
     * @param data The RPC log record object.
     * @returns return the Promise<void> object.
     */
    public handler(data: RpcDialogOverlayData): Promise<void> {
        return this.processNextForSubject(RpcOverlayOpenKey.command, data);
    }
}
